export function formatChartTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${String(secs).padStart(2, "0")}`;
}

export function getChartTickIntervalSeconds(totalSeconds: number): number {
  if (totalSeconds <= 300) return 30;
  if (totalSeconds <= 900) return 60;
  if (totalSeconds <= 1800) return 120;
  if (totalSeconds <= 3600) return 300;
  if (totalSeconds <= 7200) return 600;
  return 900;
}

export function createChartTimeTickFormatter(data: Array<{ time: number; timeLabel: string }>) {
  if (data.length === 0) return () => "";

  const totalSeconds = data[data.length - 1]?.time || 0;
  const intervalSeconds = getChartTickIntervalSeconds(totalSeconds);

  const labelTimes = new Set<number>();
  for (let t = 0; t <= totalSeconds; t += intervalSeconds) {
    labelTimes.add(t);
  }
  if (totalSeconds > 0) {
    labelTimes.add(totalSeconds);
  }

  return (value: string) => {
    const dataPoint = data.find((d) => d.timeLabel === value);
    if (!dataPoint) return "";

    const timeSeconds = dataPoint.time;
    const roundedTime = Math.round(timeSeconds / intervalSeconds) * intervalSeconds;
    const tolerance = intervalSeconds * 0.1;
    if (Math.abs(timeSeconds - roundedTime) <= tolerance || labelTimes.has(timeSeconds)) {
      return formatChartTime(roundedTime);
    }
    return "";
  };
}
